export const moduleName = 'subscription';

export default {
  ACTIVATE_ACTIVATION_CODE_ERROR: `${moduleName}/ACTIVATE_ACTIVATION_CODE_ERROR`,
  ACTIVATE_ACTIVATION_CODE_REQUEST: `${moduleName}/ACTIVATE_ACTIVATION_CODE_REQUEST`,
  ACTIVATE_ACTIVATION_CODE_SUCCESS: `${moduleName}/ACTIVATE_ACTIVATION_CODE_SUCCESS`,
  ACTIVATE_MOBILE_VIDEO_LICENSE_FAILURE: `${moduleName}/ACTIVATE_MOBILE_VIDEO_LICENSE_FAILURE`,
  ACTIVATE_MOBILE_VIDEO_LICENSE_REQUEST: `${moduleName}/ACTIVATE_MOBILE_VIDEO_LICENSE_REQUEST`,
  ACTIVATE_MOBILE_VIDEO_LICENSE_SUCCESS: `${moduleName}/ACTIVATE_MOBILE_VIDEO_LICENSE_SUCCESS`,
  DEACTIVATE_RECURRING_PAYMENT_FAILURE: `${moduleName}/DEACTIVATE_RECURRING_PAYMENT_FAILURE`,
  DEACTIVATE_RECURRING_PAYMENT_REQUEST: `${moduleName}/DEACTIVATE_RECURRING_PAYMENT_REQUEST`,
  DEACTIVATE_RECURRING_PAYMENT_SUCCESS: `${moduleName}/DEACTIVATE_RECURRING_PAYMENT_SUCCESS`,
  GET_MOBILE_VIDEO_LICENSE_FAILURE: `${moduleName}/GET_MOBILE_VIDEO_LICENSE_FAILURE`,
  GET_VAT_VERIFICATION_ERROR: `${moduleName}/GET_VAT_VERIFICATION_ERROR`,
  GET_VAT_VERIFICATION_REQUEST: `${moduleName}/GET_VAT_VERIFICATION_REQUEST`,
  GET_VAT_VERIFICATION_SUCCES: `${moduleName}/GET_VAT_VERIFICATION_SUCCES`,
  INVALIDATE_CODE_DATA: `${moduleName}/INVALIDATE_CODE_DATA`,
  PAYMENT_RESULT_FROM_SOCKET: `${moduleName}/PAYMENT_RESULT_FROM_SOCKET`,
  SET_PAYMENT_RESULT: `${moduleName}/SET_PAYMENT_RESULT`,
  USE_AVAILABLE_CREDIT_REQUEST: `${moduleName}/USE_AVAILABLE_CREDIT_REQUEST`,
};
